/* eslint-disable import/no-extraneous-dependencies */
import Vue from 'vue';
import '@firebase/polyfill';
import Buefy from 'buefy';
import '@mdi/font/css/materialdesignicons.css';
import '@/styles/main.scss';
import { i18n } from '@/utils/i18n-setup';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
import VueCookies from 'vue-cookies';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import './vee-validate';

Vue.config.productionTip = false;
Vue.use(Buefy);
Vue.use(VueMoment, {
  moment,
});
Vue.use(VueCookies);
new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
